import React from "react"
import { graphql } from "gatsby"
import NewLayout from "../components/new_layout"
import MainSection100 from "../components/Layout/main-section-100"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import MainSection50 from "../components/Layout/main-section-50"
import { AgendaTask } from "../components/v2025/agenda-task"
import SEO from "../components/seo"
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"
import { Container, Container50 } from '../components/Layout/containers';
import ImageGroup from "../components/v2024/image/image-group"
import Tag from "../components/v2023/UI/Tag/tag"
import { getEventDateFormatted } from "../utils/gatsby-helpers"
import MenuModalState from "../components/v2024/Login/modal-login-state"
import { ModalForm } from "../components/v2024/modal"

const TecalisEvent = ({ data, pageContext }) => {
    const tecalisEvent = data.tecalisEvent
    const modalState = MenuModalState()

    let location = tecalisEvent.location.town ?? ""
    location += (location !== "" && tecalisEvent.location.city != null ? ", " : "") + (tecalisEvent.location.city ?? "")
    location += (location !== "" && tecalisEvent.location.province != null ? ", " : "") + (tecalisEvent.location.province ?? "")
    location += (location !== "" && tecalisEvent.location.country != null ? ", " : "") + (tecalisEvent.location.country ?? "")

    const ctaButton = {
        text: tecalisEvent.cta.button,
        url: tecalisEvent.cta.url,
        blank: tecalisEvent.cta.blank
    }

    return (
        <NewLayout pageContext={pageContext} thinFooter footerNoColor>
            <SEO
                lang={pageContext.langKey}
                title={tecalisEvent.seo.title}
                description={tecalisEvent.seo.meta_description}
                translates={pageContext.translates}
                image={tecalisEvent.seo?.image_2?.localFile?.publicURL}
            />

            {/* MAIN SECTION */}
            <main className="event">
                <div className="event__hero">
                    <MainSection100 hero noContainer>
                        <Container>
                            <div>
                                <GatsbyImage image={getImage(tecalisEvent.event_image.localFile)} alt={tecalisEvent.event_image.alternativeText} />
                            </div>
                            <div className="button__wrapper">
                                {tecalisEvent.date_start && <Tag tag={{ name: getEventDateFormatted(tecalisEvent, pageContext.langKey), type: 'Event' }} />}
                                <Tag tag={{ name: location, type: 'Event' }} />
                                <Tag tag={{ name: tecalisEvent.type, type: 'Event' }} />
                            </div>
                            <div className="container__text">
                                <h1 className="hero">{tecalisEvent.title}</h1>
                                <ReactMarkdown children={tecalisEvent.hero_description} rehypePlugins={[rehypeRaw]} />
                            </div>
                            <div className="container__text-more-info">
                                <div className="button__wrapper">
                                    {/* <LinkButton button={tecalisEvent.hero_button} className="button button--event-light" /> */}
                                    <button onClick={() => { modalState.openMenu() }} className="button button--event-light">
                                        {tecalisEvent.hero_button.text}
                                    </button>
                                </div>
                                {tecalisEvent.hero_button_description && <span>{tecalisEvent.hero_button_description}</span>}
                            </div>
                        </Container>
                    </MainSection100>
                    {/* animacion hero */}
                    <div class="event__hero__animation">
                        <div class="light-1"></div>
                        <div class="light-2"></div>
                        <div class="light-3"></div>
                        <div class="light-4"></div>
                        <div class="light-5"></div>
                        <div class="light-6"></div>
                    </div>
                </div>

                {/* INFORMATION & CHARACTERISTICS */}
                <MainSection100>
                    <Container center text>
                        <h2>{tecalisEvent.information_title}</h2>
                        <ReactMarkdown children={tecalisEvent.information_description} rehypePlugins={[rehypeRaw]} />
                        <div className="grid-lg-2">
                            {tecalisEvent.characteristics.map((characteristic, index) => (
                                <ImageGroup
                                    basicInfoWithImage={characteristic}
                                    key={index}
                                    animation={{ "data-aos": "zoom-in", "data-aos-delay": 200 * index }}
                                />
                            ))}
                        </div>
                        <div className="tile tile--dark-gray">
                            <ReactMarkdown children={tecalisEvent.information_cta} rehypePlugins={[rehypeRaw]} />
                        </div>
                    </Container>
                </MainSection100>

                {/* AGENDA */}
                <MainSection50 sectionType="color" sectionColor="event-dark" sectionSize="lg"
                    childrenLeft={
                        <div className="container__text">
                            <h2>{tecalisEvent.agenda_title}</h2>
                            <p>{tecalisEvent.agenda_description}</p>
                        </div>
                    }
                    childrenRight={
                        <div className="tile--group-agenda">
                            {tecalisEvent.agenda_tasks.map(task =>
                                <AgendaTask task={task} />
                            )}
                        </div>
                    }
                />

                {/* CTA */}
                <div className="main__section main__section--100">
                    <div className="container">
                        <div className="tile tile--green tile--lg">
                            <h3>{tecalisEvent.cta.name}</h3>
                            <div className="tile__body">
                                <ReactMarkdown children={tecalisEvent.cta.description} rehypePlugins={[rehypeRaw]} />
                            </div>
                            {/* <LinkButton button={ctaButton} className="button button--event-dark" /> */}
                            <button onClick={() => { modalState.openMenu() }} className="button button--event-dark">
                                {ctaButton.text}
                            </button>
                        </div>
                    </div>
                </div>

                {/* MODAL */} 
                <ModalForm 
                    state={modalState}
                    eventName={tecalisEvent.hubspot_event_name}
                    form={tecalisEvent.event_form}
                />
            </main>
        </NewLayout>
    )
}

export default TecalisEvent

export const query = graphql`
    query ($id: String!, $langKey: String!) {
        tecalisEvent: strapiTecalisEvents (id: {eq: $id}, locale: {eq: $langKey}) {
            seo {
                title
                meta_description
                image_2 {
                    localFile {
                        publicURL
                    }
                }
            }
            event_image {
                alternativeText
                localFile {
                    childImageSharp {
                        gatsbyImageData(
                            quality: 100
                            placeholder: BLURRED
                            formats: [WEBP]
                        )
                    }
                }
            }
            date_start
            date_end
            type
            location {
                address
                city
            }
            title
            hero_description
            hero_button {
                text
                url
            }
            hero_button_description
            information_title
            information_description
            characteristics {
                description    
                image {
                    alternativeText
                    localFile {
                        childImageSharp {
                            gatsbyImageData(
                                width: 80
                                quality: 100
                                placeholder: BLURRED
                                formats: [WEBP]
                            )
                        }
                    }
                }
            }
            information_cta
            agenda_title
            agenda_description
            agenda_tasks {
                title
                description
            }
            cta {
                name
                description
                button
                url
                blank
            }
            event_form {
                region
                portal_id
                form_id
            }
            hubspot_event_name
        }
    }
`
